export const REQUIRED_FIELD_ERROR = 'Required field'
export const INVALID_EMAIL_ERROR = 'Please put a correct e-mail'
export const MAX_TEXT_LIMIT = 255
export const TEXT_LIMIT_ERROR =
  'Your have exceeded the maximum character limit.'
